// INSEE legal categories (three-level nomenclature, four-digit level III
// codes) reduced to the SIGLE a cabinet reads on an identity line: « 5499 »
// says nothing, « SARL » does. Deliberately partial (the categories a cabinet
// meets); an unknown code resolves to null and the screen shows the raw code
// rather than an invented sigle.
//
// La matière, relue par l'expert-comptable :
// Source : INSEE, « Catégories juridiques » (insee.fr/fr/information/2028129),
// nomenclature révisée au 01/09/2022. Les codes 5498 (EURL) et 5720 (SASU)
// ont été SUPPRIMÉS le 01/07/2020 (fusionnés dans 5499 et 5710) : ils
// restent ici parce que des données anciennes les portent encore, et que le
// sigle qu'ils désignaient reste juste. Chaque code ci-dessous a été vérifié
// le 11/10/2026 sur les sources INSEE (la page ci-dessus pour 1000 et 5785,
// l'énumération xml.insee.fr/schema/cj-enum pour les autres) ; 5699 y est
// libellé différemment selon l'édition de la nomenclature, mais désigne une
// SA dans les deux.
const SIGLES_PAR_CODE: Readonly<Record<string, string>> = {
  "1000": "EI",
  "5202": "SNC",
  "5485": "SELARL",
  "5498": "EURL",
  "5499": "SARL",
  "5599": "SA",
  "5699": "SA",
  "5710": "SAS",
  "5720": "SASU",
  "5785": "SELAS",
  "6220": "GIE",
  "6540": "SCI",
  "6599": "Société civile",
  "9220": "Association",
};

/** The sigle of an INSEE legal category, or null for an unknown code. */
export function resolveCategorieJuridique(code: string): string | null {
  return SIGLES_PAR_CODE[code] ?? null;
}
